module.exports = __webpack_public_path__ + "static/img/18050B_3_4_C_20230520_fit.2b28885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18050B_3_4_C_20230520_fit.png
// module id = MiS+
// module chunks = 0